import React from 'react';
import Nav from './Nav/Nav';
import Partner from './Partner/Partner';
import More from './More/More';

const Footer = ({cms}) => {
    const [navigation, setNavigation] = React.useState({});
    const [socials, setSocials] = React.useState([]);
    const [partners, setPartners] = React.useState([]);
    const [copyright, setCopyright] = React.useState();
    const [acknowledgement, setAcknowledgement] = React.useState();
    const [more, setMore] = React.useState();

    React.useEffect(() => {
        setNav();
        if(cms.siteSettings && cms.siteSettings.social){
            setSocials(cms.siteSettings.social);
        }
        if(cms.siteSettings && cms.siteSettings.copyright){
            setCopyright(cms.siteSettings.copyright);
        }
        if(cms.siteSettings && cms.siteSettings.acknowledgement){
            setAcknowledgement(cms.siteSettings.acknowledgement);
        }
        if(cms.nav && cms.nav.more){
            setMore(cms.nav.more);
        }
        if(cms.footer && cms.footer.partners) {
            setPartners(cms.footer.partners);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function setNav() {
        let nav = {};
        if (cms.nav && cms.nav.siteNav) {
            for (let menu in cms.nav.siteNav) {
                nav[menu] = {
                    heading: cms.nav.siteNav[menu].title,
                    items: []
                };
                if(cms.nav.siteNav[menu] && cms.nav.siteNav[menu].categories){
                    cms.nav.siteNav[menu].categories.forEach(category => {
                        category.navItems.forEach(item => {
                            if (item.footer) {
                                nav[menu].items.push(item);
                            }
                        })
                    });
                }
                
            }
        }
        setNavigation(nav);
    }

    return ( 
        <footer>
            {(navigation && socials) && <Nav nav={navigation} socials={socials} />}
            { partners && <Partner partners={partners} />}
            {(copyright && more && acknowledgement) && <More copyright={copyright} more={more} acknowledgement={acknowledgement}/>}
        </footer>
    );
}
 
export default Footer;